import { useLocation, useNavigate } from 'react-router-dom';

import { useLanguage } from './LanguageContext';

const PREFIX = /^\/(en|pl)(\/.*)?$/;

// When the visitor arrived on a language-prefixed URL (/pl, /en/about, ...),
// keep links and the language switch on prefixed URLs so a refresh or a
// shared link keeps the language.
const useLanguageRouting = () => {
  const { lang, toggleLang } = useLanguage();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const match = pathname.match(PREFIX);

  const localize = (path) => {
    if (!match || path.startsWith('/resume')) return path;
    return `/${lang}${path === '/' ? '' : path}`;
  };

  const switchLanguage = () => {
    const next = lang === 'en' ? 'pl' : 'en';
    toggleLang();
    if (match) navigate(`/${next}${match[2] || ''}`);
  };

  return { localize, switchLanguage };
};

export default useLanguageRouting;
